import { render, staticRenderFns } from "./gr-wunsch-icon.vue?vue&type=template&id=60c437ca"
import script from "./gr-wunsch-icon.vue?vue&type=script&lang=js"
export * from "./gr-wunsch-icon.vue?vue&type=script&lang=js"
import style0 from "./gr-wunsch-icon.vue?vue&type=style&index=0&id=60c437ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports